import React from 'react';
import '../styles/LegalPages.css';

function Privacy() {
    return (<div className="legal-page">
        <div className="legal-container">
            <h1>Privacidad y Política de Protección de Datos Personales</h1>
            <p className="last-updated">Última actualización: Diciembre 2024</p>

            {/* 1. AVISO LEGAL */}
            <section className="legal-section">
                <h2>1. AVISO LEGAL</h2>
                <p>
                    BEEZ CIA LTDA. requiere que todos los visitantes a esta aplicación móvil y Jama App Web (en
                    adelante “App Jama”) se adhieran a los términos y condiciones que aparecen a continuación. Por
                    el sólo hecho de acceder y hacer uso de este App Jama, usted (el «Usuario») se adhiere de forma
                    inmediata a todos y cada uno de los siguientes términos y condiciones.
                </p>
                <p>
                    Este Aviso de Privacidad, se pone a disposición de las personas que hayan entregado datos
                    personales conforme a la Ley Orgánica de Protección de Datos en Ecuador, antes o después del
                    inicio de vigencia de dicha Ley y solo para los propósitos de los productos y servicios
                    ofrecidos por BEEZ CIA LTDA.

                </p>
            </section>

            {/* 2. TERMINOLOGÍA */}
            <section className="legal-section">
                <h2>2. TERMINOLOGÍA</h2>
                <p>
                    Para todos los efectos prácticos y legales a que haya lugar, se advierte al Usuario que en el
                    texto de este App Jama, se utilizan las palabras «BEEZ CIA LTDA. » para referirse a la compañía
                    BEEZ CIA LTDA.

                </p>
            </section>

            {/* 3. SERVICIOS */}
            <section className="legal-section">
                <h2>3. SERVICIOS</h2>
                <p>
                    Los beneficios y coberturas a que hace referencia este App Jama están sujetos a los términos,
                    condiciones de acuerdo a lo que se establezca en los instrumentos jurídicos, entregado a cada
                    cliente.

                </p>
            </section>

            {/* 4. MARCAS */}
            <section className="legal-section">
                <h2>4. MARCAS Y DERECHOS DE AUTOR</h2>
                <p>
                    Las marcas, avisos, nombres comerciales y demás propiedades intelectuales (indistintamente, las
                    «Marcas») que aparecen en este App Jama, son propiedad exclusiva de BEEZ CIA LTDA. o del
                    legítimo propietario de las mismas. Queda estrictamente prohibido cualquier uso o explotación de
                    las «Marcas»(inclusive su uso como «metatags»), sin el consentimiento previo y por escrito de
                    BEEZ CIA LTDA. o de su legítimo propietario.
                </p>
                <p>
                    El diseño y contenido de este App Jama, así como cualquier programa de cómputo que aparezca en
                    el mismo, se encuentra debidamente protegido ante las autoridades y registros competentes, por
                    lo que queda estrictamente prohibido, de manera enunciativa más no limitativa: modificar,
                    copiar, distribuir, transmitir, desplegar, publicar, editar, vender o de cualquier forma
                    explotar el diseño y contenido de este App Jama con fines comerciales o privados.
                </p>
            </section>

            {/* 5. IDENTIDAD Y DOMICILIO */}
            <section className="legal-section">
                <h2>5. IDENTIDAD Y DOMICILIO DEL RESPONSABLE DEL TRATAMIENTO DE DATOS PERSONALES</h2>
                <p>
                    BEEZ CIA LTDA. identificada con el registro de contribuyentes No. 1091789716001, con domicilio
                    en la ciudad de Ibarra, Provincia de Imbabura, República del Ecuador, trata los datos
                    personales, de sus clientes (en adelante “datos personales”), de forma estrictamente privada y
                    confidencial, para fines determinados.
                </p>
                <p>
                    Por ello, la obtención, tratamiento, transferencia y ejercicio de los derechos derivados de
                    dichos datos personales, se hace mediante un uso adecuado, legítimo y lícito, salvaguardando
                    permanentemente los derechos de licitud, consentimiento, información, proporcionalidad,
                    responsabilidad y finalidad, de conformidad con lo dispuesto por la Ley Orgánica de Protección
                    de Datos Personales de Ecuador.

                </p>
            </section>

            {/* 6. ¿QUÉ SON DATOS PERSONALES? */}
            <section className="legal-section">
                <h2>6. ¿QUÉ SON DATOS PERSONALES?</h2>
                <p>
                    Se considera un dato personal a cualquier tipo de información o datos que pueden identificar a
                    una persona, directa o indirectamente (p. ejem. nombres, correo electrónico, cédula de
                    identidad, entre otros). De conformidad con la Ley Orgánica de Protección de Datos Personales
                    vigente en la República del Ecuador, el tratamiento de datos personales de los titulares debe
                    ser realizado de tal manera que se garanticen sus derechos legalmente reconocidos.
                </p>
            </section>

            {/* 7. BASE LEGAL */}
            <section className="legal-section">
                <h2>7. BASE LEGAL PARA UTILIZAR DATOS PERSONALES Y LEY APLICABLE</h2>
                <p>
                    El acceso y utilización de este App Jama se encuentra sujeto a las disposiciones aplicables a la
                    legislación Ecuatoriana. Los datos personales recopilados por Beez CIA LTDA., son tratados en
                    estricta aplicación de la Constitución de la República del Ecuador, Ley Orgánica de Protección
                    de Datos Personales, su Reglamento, y toda la normativa secundaria emitida por la Autoridad de
                    Protección de Datos Personales en el Ecuador.
                </p>
                <p>
                    En lo relacionado con el tratamiento de datos personales de ciudadanos extranjeros, se estará a
                    lo dispuesto por la normativa internacional y/o extranjera aplicable a la materia, en aplicación
                    del principio de favorabilidad para el titular, según cada caso.
                </p>
            </section>

            {/* 8. OBTENCIÓN DE DATOS */}
            <section className="legal-section">
                <h2>8. OBTENCIÓN DE DATOS PERSONALES</h2>
                <p>
                    Estamos comprometidos con salvaguardar la privacidad de sus datos personales y mantener una
                    relación estrecha y activa con nuestros clientes. Por eso, además de éste Aviso, aplicamos
                    nuestra Política de Privacidad disponible a continuación.
                </p>
                <p>
                    Los Datos Personales antes enunciados, incluso aquellos de carácter sensible, proporcionados por
                    usted a través de solicitudes y/o través de diversas formas de contacto cuestionarios o formatos
                    relacionados con los productos y/o servicios ofertados a través de terceros autorizados por BEEZ
                    CIA LTDA. por vía electrónica, óptica, sonora, visual; por cualquier otro medio o tecnología, y
                    aquellos generados con motivo de la relación jurídica que se haya celebrado o que se celebre con
                    usted, serán tratados para los fines vinculados en este instrumento.
                </p>
                <p>
                    A continuación, señalamos de forma expresa y limitante los datos que podremos recabar de usted:
                </p>
                <ul>
                    <li><strong>Datos Personales:</strong></li>
                </ul>
                <p>
                    Información personal y no personal, como nombre, ubicación, datos de contacto, financieros,
                    gustos, preferencias. Los datos se recaudan por la información que usted suministra y también de
                    forma automática a través de la interacción en el sitio web o a través de aplicativos on-line
                    y/o cookies, web beacons u otras funcionalidades desarrolladas o por desarrollar que permiten
                    recaudar información relacionada con el ingreso, uso y navegación en el sitio web Jama y app
                    móvil Jama a, esto con el fin de facilitar la prestación de los servicios y el mejoramiento
                    continuo de Beez CIA LTDA. La información recaudada tiene como finalidad particular permitir la
                    interacción entre la app Jama y el cliente, la entrega del producto y de pagos dentro de Beez
                    CIA LTDA. Así mismo para definir perfiles de consumo; elaboración de estudios de mercadeo;
                    análisis estadísticos; ofrecimiento de promociones, ofertas, publicidad, mercadeo, difusión del
                    portal y de otros negocios propios o de terceros, aliados o relacionados; ofertas de productos y
                    servicios propios o de terceros; gestión del riesgo comercial, ciberseguridad, información y
                    actividades en las cuales se relacionan y vinculan con Beez CIA LTDA o sus empresas vinculadas o
                    aliadas;
                </p>
                <p>
                    El cliente al acceder a los datos del consumidor se encarga de los datos y queda sujeto a las
                    normas de Protección de Datos Personales, así como obligado a solicitar, por su cuenta,
                    autorización directa del consumidor para el uso de datos personales para fines diferentes de la
                    transacción en la App Jama.
                </p>
            </section>

            {/* 9. FINALIDADES */}
            <section className="legal-section">
                <h2>9. FINALIDADES PARA EL TRATAMIENTO DE DATOS PERSONALES</h2>
                <p>
                    Respecto de los datos personales antes mencionados, se garantiza que, ya sea directa o
                    indirectamente a través de sus subsidiarias, afiliadas o empresas relacionadas, terceros,
                    proveedores de servicios, con quienes tiene una relación jurídica, quienes recogen y tratan
                    datos personales por cuenta de BEEZ CIA LTDA. tratarán los datos personales para las finalidades
                    para las que los titulares dieron su consentimiento y que estos datos son necesarios para la
                    existencia, mantenimiento y cumplimiento de la relación jurídica establecida entre BEEZ CIA
                    LTDA. sus clientes , que son las siguientes:
                </p>
                <p>
                    (i) Enviar comunicaciones e información publicitaria o promocional; (ii) ser usada para realizar
                    invitaciones a eventos; (iii) ser utilizada como herramientas para el ofrecimiento de productos
                    o servicios propios o de terceros, comercializados por BEEZ CIA LTDA., su matriz y/o afiliadas;
                    (iv) ser usadas en campañas de mercadeo digital y mercadeo en redes sociales; (v) contactarlo en
                    caso de solicitudes, quejas, y/o reclamos; (vi) para que la información sea transferida y/o
                    transmitida a terceros ubicados en la República del Ecuador u otros países, y usada por BEEZ CIA
                    LTDA., su matriz, filiales y subordinadas o terceros, dentro o fuera de la República del Ecuador
                    para cualquiera de los fines previstos en esta autorización; (vii) para ser contactado a través
                    de cualquier medio para realizar gestiones de venta directa de los productos o servicios propios
                    y/o de terceros, comercializados por BEEZ CIA LTDA.; (viii) para ser contactado a través de
                    cualquier medio para realizar gestiones de post-venta de los productos o servicios propios y/o
                    de terceros, comercializados por BEEZ CIA LTDA.; (ix) contactarlo para realizar encuestas,
                    estudios y/o confirmación de datos personales; (x) análisis estadísticos internos o para el
                    envío de noticias relacionadas con campañas de fidelización o mejora de servicio; (xi) ser usada
                    como elemento de análisis por parte de BEEZ CIA LTDA. para establecer, mantener y cumplir con
                    las obligaciones o compromisos en una relación contractual o comercial, cualquiera que sea su
                    naturaleza; (xii) ser usada por parte de BEEZ CIA LTDA. para el adelantamiento de cualquier
                    trámite ante una autoridad pública o una persona o entidad privada, respecto del cual la
                    información resulte pertinente; (xiii); ser usada por parte de BEEZ CIA LTDA. como elemento de
                    análisis y soporte en el cumplimiento de un deber legal, cualquiera que sea su naturaleza,
                    contactarlo en caso de solicitudes, quejas, y/o reclamos; (xiv) almacenar dicha información en
                    sus bases de datos; (xv) utilizar dicha información para asignar clave de acceso a la Página Web
                    y o Medios Digitales de BEEZ CIA LTDA.; (xvi) poner en circulación dicha información para que
                    sea verificada, consultada y/o utilizada con fines relacionados con la actividad de BEEZ CIA
                    LTDA., tanto por sus empleados en desarrollo de sus funciones como por terceras personas,
                    incluyendo, transportistas, entidades financieras y centrales de riesgo; (xvii) reportar y/o
                    consultar el incumplimiento de las obligaciones contractuales, frente a BEEZ CIA LTDA. y/o
                    frente a cualquier persona natural o jurídica de naturaleza pública o privada, (o en) las
                    centrales de riesgo que BEEZ CIA LTDA. o quien represente sus intereses juzgue necesario.
                    (xviii) enviar comunicaciones a través de correo físico directo, correo electrónico o llamada
                    telefónica grabada o mensaje de texto o voz, a las direcciones y números suministrados, incluida
                    la comunicación, previa al reporte a las centrales de riesgo del incumplimiento de mis
                    obligaciones; (xix) que los mensajes vía teléfono sean trasmitidos a cualquier tercero que
                    conteste las llamadas telefónicas hechas al número que suministre, o que consulte el mensaje de
                    voz o texto que se envíe al mismo número; (xx) poner en circulación dicha información para que
                    sea verificada, consultada y/o utilizada por los transportistas en la parte que sea necesaria
                    para cumplir con la entrega de cualquier pedido de los productos o servicios propios y/o de
                    terceros, comercializados por BEEZ CIA LTDA.; (xxi) poner en circulación dicha información para
                    que sea verificada, consultada y/o utilizada por la compañía que tenga contratada BEEZ CIA LTDA.
                    en la parte que sea necesaria para cumplir con el escaneo de cualquier pedido de los productos
                    comercializados por BEEZ CIA LTDA. ; (xxii) poner en circulación dicha información para que sea
                    verificada, consultada y/o utilizada por las entidades financieras en la parte que sea necesaria
                    para recibir los pagos que efectúe.
                </p>
                <ul>
                    <li>Otros: BEEZ CIA LTDA. Podrá recabar datos personales de terceras personas a través de sus
                        Clientes para fines de facturación y/o firma de contratos y otros instrumentos, para lo cual
                        deberá mediar autorización del titular.
                    </li>
                </ul>
                <p>
                    De manera adicional, BEEZ CIA LTDA. podrá tratar sus datos personales para las siguientes
                    finalidades distintas o secundarias, que no son necesarias para la existencia, mantenimiento y
                    cumplimiento de la relación jurídica antes mencionada, pero que nos permiten brindarle una mejor
                    atención:
                </p>
                <ul>
                    <li>Ofrecimiento y promoción de bienes, productos y servicios y/o prospección comercial de las
                        entidades que formen directa o indirectamente parte de BEEZ CIA LTDA.</li>
                </ul>
                <ul><li>
                    Mercadotecnia, publicidad, prospección comercial, evaluación de nuestros productos y servicios
                    incluyendo el envío de muestras gratis, artículos promocionales u obsequios.
                </li></ul>
                <ul><li>
                    Para contactarlo en caso de solicitudes, quejas y/o reclamos.
                </li></ul>
                <ul><li>
                    Para contactarlo a través de cualquier medio para realizar gestiones de venta directa de los
                    productos o servicios ofertados por BEEZ CIA LTDA.
                </li></ul>
                <ul><li>
                    Para contactarlo para realizar encuestas, estudios y/o confirmación de datos personales.
                </li></ul>
                <ul><li>
                    Para ser utilizados para análisis estadísticos internos o para el envío de noticias relacionadas
                    con mejoras de servicio.
                </li></ul>
                <ul><li>
                    Trámites ante autoridades en la República del Ecuador, respecto del cual la información resulte
                    pertinente.
                </li></ul>
                <ul><li>
                    Como elemento de análisis y soporte en el cumplimiento de un deber legal, cualquiera sea su
                    naturaleza.
                </li></ul>
                <ul><li>
                    Para que los datos personales sean verificados, consultados y/o utilizados por las entidades
                    financieras en la parte que sea necesaria para recibir los pagos que efectúe de los servicios
                    contratados.
                </li></ul>
                <ul><li>
                    Reportar y/o consultar el incumplimiento de las obligaciones contractuales, frente a BEEZ CIA
                    LTDA.
                </li></ul>
                <p>
                    La negativa de consentimiento para el tratamiento de sus datos personales para las finalidades
                    primarias y secundarias señaladas previamente, no podrá ser un motivo para que le neguemos los
                    productos o servicios derivados de la adquisición de los productos o servicios que adquiere o
                    contrata con nosotros.
                </p>
                <p>
                    Es importante mencionar que, en caso de que BEEZ CIA LTDA. Pretendiera utilizar datos personales
                    sensibles para las finalidades secundarias descritas con anterioridad, previo a su tratamiento,
                    solicitará su consentimiento expreso y por escrito de conformidad con la Ley y demás
                    disposiciones aplicables, de lo contrario no hará uso de los mismos para estos fines.
                </p>
                <p>
                    Los datos personales que usted proporcione a BEEZ CIA LTDA. serán tratados exclusivamente para
                    las finalidades descritas, se les tratará de forma confidencial y exclusivamente en la medida en
                    que éstos sean estrictamente necesarios para cumplir la finalidad para la cual hubieren sido
                    recabados.
                </p>
                <p>
                    Para prevenir el acceso no autorizado a sus datos personales y con el fin de asegurar que la
                    información sea utilizada para los fines establecidos en este aviso de privacidad, hemos
                    implementado procedimientos físicos, electrónicos y administrativos, utilizando tecnologías
                    avanzadas que limitan el uso o divulgación de sus datos, permitiéndonos tratarlos debidamente y
                    prohibiendo extraer de las oficinas de BEEZ CIA LTDA., de forma no autorizada, cualquier tipo de
                    información que contenga datos personales.
                </p>
            </section>

            {/* 10. CONSENTIMIENTO */}
            <section className="legal-section">
                <h2>10. CONSENTIMIENTO LIBRE E INFORMADO</h2>
                <p>
                    En cumplimiento con lo dispuesto por la Ley Orgánica de Protección de Datos Personales, BEEZ CIA
                    LTDA., hace de su conocimiento que tratará los datos personales que usted proporcione. Podremos
                    reunir o recibir sus datos por medio de nuestros sitios web, formularios, aplicaciones,
                    dispositivos, páginas de marcas o productos, en redes sociales o de cualquier otra manera. En
                    ese sentido, usted otorga su consentimiento voluntario, libre, previo, expreso, específico,
                    informado, e inequívoco a BEEZ CIA LTDA.,sus subsidiarias, filiales o vinculadas, terceros,
                    contratistas y proveedores, para que realicen el tratamiento, destino, flujo y transferencia, en
                    cualquiera de sus modalidades, medios o soportes, local o transfronterizo, de la información y
                    los datos personales y de identificación que usted haya podido proporcionar bajo cualquier medio
                    o modalidad, directa o indirecta, sea por vía virtual o física, para los fines descritos en este
                    instrumento.
                </p>
            </section>

            {/* 11. DERECHOS DEL TITULAR */}
            <section className="legal-section">
                <h2>11. DERECHOS DEL TITULAR DE DATOS PERSONALES</h2>
                <p>
                    Reconozco que mis derechos, como titular de los datos personales, son los previstos el Régimen
                    de Protección de Datos Personales en la República del Ecuador, especialmente los siguientes: (i)
                    Acceder en forma gratuita a los datos proporcionados que hayan sido objeto de tratamiento; (ii)
                    solicitar la actualización y rectificación de la información frente a datos parciales,
                    inexactos, incompletos, fraccionados, que induzcan a error, o a aquellos cuyo tratamiento esté
                    prohibido o no haya sido autorizado; (iii) solicitar prueba de la autorización otorgada; (iv)
                    presentar quejas por infracciones a lo dispuesto en la normatividad vigente; (v) Revocar la
                    autorización y/o solicitar la supresión del dato, a menos que exista un deber legal o
                    contractual que haga imperativo conservar la información; (vi) abstenerme de responder las
                    preguntas sobre datos sensibles (vii) solicitar la modificación, rectificación y/o eliminación
                    de la información almacenada en las bases de datos de BEEZ CIA LTDA.; (viii) solicitar el acceso
                    inmediato a mis datos personales; (viii) derecho a la oposición; (ix) derecho a la portabilidad
                    de sus datos personales; (x) derecho a la suspensión del tratamiento; (xi) derecho a consultar
                    que tipos de datos tiene el responsable del tratamiento de datos personales.
                </p>
                <p>
                    En relación con el tratamiento de datos sensibles, BEEZ CIA LTDA.,garantiza que estos estarán
                    sujetos en todo momento a ser confidenciales, protegidos contra el tratamiento no autorizado o
                    ilícito, contra su daño o pérdida, así como al secreto confidencial en todo caso, de conformidad
                    con las disposiciones legales consagradas en la Ley Orgánica de Protección de Datos Personales.

                </p>
            </section>

            {/* 12. TRANSFERENCIAS */}
            <section className="legal-section">
                <h2>12. TRANSFERENCIAS DE DATOS PERSONALES A TERCEROS.</h2>
                <p>
                    Por medio de este aviso de privacidad, BEEZ CIA LTDA. le informa que podrá transferir sus datos
                    personales de identificación y contacto (no sensibles) a terceros nacionales o extranjeros;
                    tales como a sus subsidiarias, afiliadas o empresas relacionadas y proveedores de servicios con
                    los que mantenga una relación jurídica, para las siguientes finalidades:
                    </p>
                <ul>
                    <li>
                        Autoridades financieras, ecuatorianas y extranjeras, con la finalidad de dar cumplimiento a nuestras obligaciones derivadas de leyes o tratados internacionales como institución de obligaciones tributarias, así como para el cumplimiento de notificaciones o requerimientos oficiales.
                    </li>

                    <li>
                        Autoridades judiciales, ecuatorianas y extranjeras, con la finalidad de dar cumplimiento a notificaciones, requerimientos u oficios de carácter judicial.
                    </li>

                    <li>
                        Institución de la Seguridad Social, con la finalidad de dar cumplimiento a obligaciones contenidas en la Legislación de Seguridad Social.
                    </li>

                    <li>
                        Instituciones, organizaciones o entidades del sector para fines de prevención de fraude y selección de riesgos.
                    </li>

                    <li>
                        Empresas ecuatorianas y extranjeras proveedoras de todo tipo de servicios.
                    </li>

                    <li>
                        Proveedores de todo tipo para el cumplimiento de la relación jurídica que tengamos con usted.
                    </li>

                    <li>
                        A empresas o prestadores de servicios para que éstas le puedan contactar directa o indirectamente, para llevar a cabo actividades de promoción y/u ofrecimiento de productos y/o servicios que dichas empresas puedan comercializar y/o prestar de manera conjunta con BEEZ CIA LTDA.
                    </li>
                </ul>
                <p>
                Asimismo, le informamos que en caso de que BEEZ CIA LTDA., pretenda transferir sus datos
                    personales sensibles (en caso de haberlos proporcionado) a los terceros aquí precisados para las
                    finalidades anteriormente descritas en el presente apartado, previo a su transferencia
                    solicitará su consentimiento expreso y por escrito, de lo contrario no hará uso de los mismos
                    para estos fines. En este sentido BEEZ CIA LTDA. le informa que, de conformidad con lo dispuesto
                    por la Ley Orgánica de Protección de Datos Personales, podrá transferir sus datos personales,
                    sin su consentimiento, en los casos que a continuación se especifican:
                </p>
                <p>
                    Cuando la transferencia esté prevista en una Ley o Tratado en los que la República del Ecuador
                    sea parte.
                    Cuando la transferencia sea efectuada a sociedades controladoras, subsidiarias o afiliadas bajo
                    el control común del responsable, o a una sociedad matriz o a cualquier sociedad del mismo grupo
                    de BEEZ CIA LTDA., que opere bajo los mismos procesos y políticas internas.
                    </p>
                <ul>
                    <li>
                        Cuando la transferencia sea necesaria por virtud de un contrato celebrado o por celebrar en interés del titular de datos, por parte de BEEZ CIA LTDA., y un tercero.
                    </li>

                    <li>
                        Cuando la transferencia sea necesaria o legalmente exigida para la salvaguarda de un interés público, o para la procuración o administración de justicia.
                    </li>

                    <li>
                        Cuando la transferencia sea precisa para el reconocimiento, ejercicio o defensa de un derecho en un proceso judicial.
                    </li>

                    <li>
                        Cuando la transferencia sea precisa para el mantenimiento o cumplimiento de una relación jurídica entre BEEZ CIA LTDA., y el titular de datos.
                    </li>

                    <li>
                        Cuando los datos fuesen recogidos de datos públicos.
                    </li>

                    <li>
                        Por razones de interés público en el ámbito de salud, respetando el derecho a la protección de datos y establecer medidas adecuadas y específicas para proteger los intereses y derechos fundamentales del titular.
                    </li>

                    <li>
                        Por razones de interés público, en el ámbito de salud pública por amenazas transfronterizas graves para la salud.
                    </li>

                    <li>
                        Necesario para proteger intereses vitales del interesado, en caso de que no pueda dar su consentimiento.
                    </li>

                    <li>
                        Para fines de medicina preventiva o laboral.
                    </li>

                    <li>
                        Para la obtención de un diagnóstico médico.
                    </li>
                </ul>
            </section>

            {/* 13. REVOCACIÓN */}
            <section className="legal-section">
                <h2>13. MECANISMOS Y PROCEDIMIENTOS PARA LA REVOCACIÓN DEL CONSENTIMIENTO AL TRATAMIENTO DE DATOS PERSONALES</h2>
                <p>
                    En todo momento usted podrá revocar el consentimiento que nos ha otorgado como BEEZ CIA LTDA.,
                    para el tratamiento de sus datos personales. Sin embargo, es importante que tenga en cuenta que
                    no en todos los casos podremos atender su solicitud o concluir su uso de forma inmediata, ya que
                    es posible que por alguna obligación legal requiramos seguir tratando sus datos personales.
                    Asimismo, usted deberá considerar que para ciertos fines, la revocación de su consentimiento
                    implicará que no le podamos seguir prestando el servicio que nos solicitó, o la conclusión de su
                    relación con nosotros.
                </p>
                <p>
                    Para revocar su consentimiento deberá acudir a nuestras oficinas y/o enviar un correo
                    electrónico indicando su “Solicitud de Revocación del Consentimiento” acompañando a dicha
                    solicitud los documentos que acrediten su identidad (identificación oficial) o, en su caso, de
                    quien legalmente le represente. Así también, en caso de que usted no desee que sus datos
                    personales sean tratados para las finalidades distintas o secundarias que se precisan en el
                    presente documento, sean transferidos a los terceros que se mencionan en el presente apartado y
                    para las finalidades aquí descritas, puede retirar el consentimiento otorgado.
                </p>
                <p>
                    Usted tiene derecho a acceder, rectificar, cancelar u oponerse al tratamiento de sus datos
                    personales. En este sentido, como titular de sus datos personales tiene el derecho de conocer
                    qué datos personales mantiene BEEZ CIA LTDA. En caso de ser inexactos, desactualizados o
                    incompletos (Rectificación), instruirnos a cancelarlos cuando estos resulten excesivos o
                    innecesarios para las finalidades descritas que justificaron su obtención, considere que los
                    mismos no están siendo utilizados conforme a los principios, deberes y obligaciones previstas en
                    la normativa aplicable (Cancelación), o bien, oponerse al uso de sus datos personales para fines
                    específicos (Oposición), en los casos en que la Ley así lo permita.
                </p>
                <p>
                    Usted puede limitar el uso o divulgación de sus datos personales a efectos de ser inscrito en
                    nuestro listado de exclusión denominado “Contactos que no desean envío de publicidad”, a fin de
                    que sus datos personales no sean tratados para fines mercadotécnicos, publicitarios o de
                    prospección comercial, así como para evaluación de nuestros productos y servicios por nuestra
                    parte.

                </p>
            </section>

            {/* 14. SEGURIDAD */}
            <section className="legal-section">
                <h2>14. ALMACENAMIENTO, SEGURIDAD Y PRIVACIDAD DE DATOS PERSONALES</h2>
                <p>
                    Los datos personales recogidos serán incorporados y tratados en Bancos de Datos cuya existencia
                    declaro conocer, que son automatizados garantizándose de manera expresa las medidas de seguridad
                    técnica, organizativa y legal para el tratamiento, seguridad y confidencialidad de los datos de
                    carácter personal facilitados, que se asegura igualmente para la transferencia y/o flujo
                    transfronterizo de los mismos.
                </p>
                <p>
                    Para prevenir el acceso no autorizado a sus datos personales y con el fin de asegurar que la
                    información sea utilizada para los fines establecidos en este aviso de privacidad, hemos
                    implementado procedimientos físicos, electrónicos y administrativos, utilizando tecnologías
                    avanzadas que limitan el uso o divulgación de sus datos, permitiéndonos tratarlos debidamente y
                    prohibiendo extraer de las oficinas de BEEZ CIA LTDA. de forma no autorizada, cualquier tipo de
                    información que contenga datos personales.
                </p>
                <p>
                    BEEZ CIA LTDA. cuenta con medidas tecnológicas adecuadas y suficientes, las cuales se evalúan
                    periódicamente para proteger correctamente los datos personales de nuestros clientes de accesos
                    no autorizados. Pese a todos los esfuerzos y las medidas implementadas por BEEZ CIA LTDA..para
                    proteger sus datos personales, en caso de que se produciese cualquier filtración y/o acceso no
                    autorizado de terceros, BEEZ CIA LTDA., notificará a la Autoridad de Datos Personales
                    Ecuatoriana, así como a usted, en el plazo establecido por la Ley Orgánica de Protección de
                    Datos Personales, tomando acciones inmediatas y correctivas al respecto.

                </p>
            </section>

            {/* 15. COOKIES */}
            <section className="legal-section">
                <h2>15. USO DE COOKIES, WEB BEACONS U OTRAS TECNOLOGÍAS  </h2>
                <p>
                    BEEZ CIA LTDA..podrá utilizar mecanismos en medios remotos o locales de comunicación
                    electrónica, óptica u otra tecnología; tales como cookies y web beacons, que permitan recabar
                    diversos datos de manera automática y simultánea al tiempo que usted como cliente y o futuro
                    cliente hace contacto con los mismos. Si usted quiere tener más información, por favor, consulta
                    nuestra Política de Privacidad disponible en https://beezdeliveryec.com/politica-privacidad/
                    donde podrás revisar cómo desactivarlos y en su caso, qué cookies estamos usando para recabar
                    tus datos personales.
                </p>
                <p>
                    Los cookies son aquellos archivos de datos que se almacenan en el disco duro del equipo de
                    cómputo o del dispositivo de comunicaciones electrónicas de un usuario al navegar en un sitio de
                    Internet específico, el cual permite intercambiar información de estado entre dicho sitio y el
                    navegador del usuario. La información de estado puede revelar en algunos casos medios de
                    identificación de sesión, autenticación o preferencias del usuario, así como cualquier otro dato
                    almacenado por el navegador respecto del sitio de Internet.
                </p>
                <p>
                    Se entiende por web beacons a aquella imagen visible u oculta insertada dentro de un sitio web o
                    correo electrónico, que se utiliza para monitorear el comportamiento del usuario en estos
                    medios. A través de éstos se puede obtener información como la dirección IP de origen, navegador
                    utilizado, sistema operativo, momento en que se accedió a la página, y en el caso del correo
                    electrónico, la asociación de los datos anteriores con el destinatario.
                </p>
                <p>
                    Asimismo, le informamos que los datos que se obtienen a través de estas tecnologías se
                    utilizarán exclusivamente para fines estadísticos y de revisión de resultados, sin que exista la
                    posibilidad de transferirlos a terceros.
                </p>
                <p>
                    La mayoría de los exploradores acepta las cookies automáticamente. Aun así, es posible
                    configurar cualquier explorador para evitar que acepte cookies e impedir de este modo que su
                    equipo o dispositivo las almacene. Algunos exploradores cuentan con un modo especial que
                    garantiza la eliminación de las cookies tras una visita. Consulte el manual de su explorador si
                    desea conocer los pasos exactos que permiten activar el modo correspondiente. Puede eliminar las
                    cookies que se encuentren almacenadas en su equipo o dispositivo en cualquier momento.
                </p>
                <p>
                    BEEZ CIA LTDA. se reserva el derecho de guardar cierta información en su computadora en la forma
                    de un archivo «cookie» u otro de naturaleza similar, con el propósito de adaptar la presentación
                    del App Jama a sus preferencias personales.

                </p>
            </section>

            {/* 16–22 resto igual */}
            <section className="legal-section">
                <h2>16. ACCESO A SECCIONES PROTEGIDAS MEDIANTE CONTRASEÑAS</h2>
                <p>
                    El acceso a las secciones de seguridad de este App Jama protegidas mediante claves o
                    contraseñas, se encuentra restringido únicamente a los usuarios que se encuentren debidamente
                    autorizados para tal efecto. BEEZ CIA LTDA. tomará las medidas que considere necesarias contra
                    la persona que sea sorprendida llevando a cabo actos dirigidos a acceder ilegítimamente dichas
                    secciones.
                </p>
            </section>

            <section className="legal-section">
                <h2>17. MODIFICACIONES Y CAMBIOS AL AVISO DE PRIVACIDAD </h2>
                <p>
                    Este aviso de privacidad podrá ser modificado o actualizado por BEEZ CIA LTDA., en cualquier
                    momento. Dichas modificaciones serán informadas a través de una publicación en nuestro App Jama
                    de internet posteriormente a su modificación. </p>
            </section>

            <section className="legal-section">
                <h2>18. LIMITACIÓN DE RESPONSABILIDAD </h2>
                <p>
                    BEEZ CIA LTDA. no asume ninguna especie de responsabilidad que se derive de cualquier daño o
                    perjuicio, directo o indirecto, generado o de cualquier forma relacionado con el acceso o
                    utilización de este App Jama (aun cuando BEEZ CIA LTDA. haya tenido conocimiento de la
                    posibilidad del daño), incluyendo la responsabilidad relacionada con daños ocasionados por virus
                    que infecten el/los sistema(s) de cómputo del Usuario.
                </p>
                <p>
                    Como titular de la información usted de forma libre y voluntaria declara que BEEZ CIA LTDA.le ha
                    informado de manera clara y expresa el tratamiento al cual serán sometidos sus datos personales;
                    (ii) que se me informó cuáles serán las finalidades a las cuales serán sometidos sus datos
                    personales; (iii) que en caso de recolección de mi información sensible, tengo derecho a
                    contestar o no las preguntas que me formulen y a entregar o no los datos solicitados; (iv) que
                    conoce los derechos que le asisten como Titular de sus Datos Personales; (v) que conoce la
                    identificación, dirección física o electrónica y teléfono del Responsable del Tratamiento de mis
                    Datos Personales.

                </p>
            </section>

            <section className="legal-section">
                <h2>19. CONFIDENCIALIDAD EN LAS COMUNICACIONES DEL USUARIO</h2>
                <p>
                    Salvo por lo establecido por las disposiciones legales aplicables, BEEZ CIA LTDA. hará sus
                    mejores esfuerzos por mantener la confidencialidad de las comunicaciones del Usuario
                    relacionadas con dicho contrato, que contengan información personal, que éste transmita
                    directamente a BEEZ CIA LTDA. No obstante, los registros e inscripciones que hagan los Usuarios
                    en cualquier tipo de foro de mensajes, no serán considerados como confidenciales, por lo que
                    BEEZ CIA LTDA. podrá usar y transmitir la información registrada por los Usuarios a su
                    favor. </p>
            </section>

            <section className="legal-section">
                <h2>20. APP JAMA ES LIGADOS</h2>
                <p>
                    Se encuentra estrictamente prohibido cualquier tipo de captación y/o vinculación no autorizada a
                    este App Jama. Asimismo se encuentra prohibida la enmarcación del contenido de este App Jama.
                    BEEZ CIA LTDA.. se reserva el derecho de desactivar cualquier liga (link) o marco (frame) no
                    autorizado, y no asume responsabilidad alguna respecto del contenido de cualquier otro App Jama
                    de Internet ligado o vinculado a este App Jama. El acceso a cualquier App Jama ligado o
                    vinculado será bajo el riesgo exclusivo del Usuario. </p>
            </section>

            <section className="legal-section">
                <h2>21. REGISTROS E INSCRIPCIONES DE LOS USUARIOS</h2>
                <p>
                    BEEZ CIA LTDA. no se encuentra obligada a revisar o dar contestación a los mensajes o
                    información registrada en este App Jama por los Usuarios, por lo que no asume ninguna
                    responsabilidad por dichos registros o inscripciones. Sin perjuicio de lo anterior, BEEZ CIA
                    LTDA., se reserva la facultad de monitorear dichos registros con la frecuencia que
                    discrecionalmente determine, así como a suprimir cualquier registro cuyo contenido sea, de
                    manera enunciativa mas no limitativa: (i) ilegal, inmoral, difamatorio, calumnioso, vulgar,
                    obsceno, étnica o racialmente discriminatorio, o cualquier otro material cuyo contenido incite
                    algún comportamiento o conducta que pueda ser considerada ilegal o contra las buenas costumbres,
                    o pueda acarrear algún tipo de responsabilidad; (ii) Promociones u ofertas de cualquier especie,
                    (iii) Mensajes registrados por Usuarios atribuyendo la autoría de los mismos a otras personas;
                    (iv) información personal (p.ej.: número telefónico, domicilio, números de cuenta, historial
                    laboral, etc.); (v) Mensajes registrados por terceros que pretenden hacerse pasar por voceros
                    autorizados por BEEZ CIA LTDA.; (vi) Mensajes a través de los cuales se ofrezca información
                    privada o propiedades intelectuales; (vii) Mensajes múltiples colocados por un mismo Usuario;
                    y/o (viii) Cualquier tipo de mensajes encadenados o seriados.

                </p>
            </section>

            <section className="legal-section">
                <h2>22. VIOLACIÓN A ESTOS TÉRMINOS Y CONDICIONES</h2>
                <p>
                    BEEZ CIA LTDA., se reserva el derecho de llevar a cabo todas las acciones legales que sean
                    necesarias para remediar cualquier violación a los presentes Términos y Condiciones, incluso el
                    de restringir el acceso a este App Jama a determinados Usuarios de Internet.
                </p>
            </section>
        </div>
    </div>);
}

export default Privacy;
